import React from 'react';
import ButtonV1 from '../ButtonV1';
import Styles from './styles.js'

const LandLordPays = (props) => {
    const { image, heading1, para, order1, order2,btnhref,btnname } = props
    return (
        <>
            <div className='lg:container px-6 lg:px-4 mx-auto'>


                <div className='w-full grid md:grid-cols-2 items-center gap-y-14 mb-12 '>
                    <div className={`w-full px-4 ${order1}`}>
                        <img src={image} className='w-full' />


                    </div>
                    <div className={` text-center w-full px-4 ${order2}`}>
                        <h1 className='pays_head text-2xl font-normal  text-gray-900 leading-7'>
                            {heading1}
                        </h1>
                        <p className='pays_para text-lg leading-8 font-normal text-gray-700 mb-6 mt-5'>{para}</p>
                        <div className='w-full flex justify-center'>

                            <ButtonV1
                                btnHref={`${btnhref}`}
                                btnName={`${btnname}`}
                                px="px-9"
                                py="py-4"
                                justify="center"
                                txtColor="rgb(1, 1, 1)" />

                        </div>
                       


                    </div>
                </div>

            </div>
            <Styles/>

        </>

    );
};

export default LandLordPays;
